import service from "@/utils/request"
export function getTravelOrderListApi(data) {
    return service({
        url: '/travelOrder/getOrderList',
        method: 'get',
        params:data
    })
}



